<template>
  <div class="media-collections">

    <div v-if="collection.type === 'callout'">
      <media-collection-callout
        :collection="collection">
      </media-collection-callout>
    </div>

    <div v-else-if="collection.media !== undefined && collection.media.length > 0">
      <h2 class="section__title">{{collection.heading}}</h2>
      <el-row :gutter="30">
        <el-col :sm="8"
                v-for="mediaItem in collection.media"
                :key="mediaItem.id">

          <media-video-excerpt
            v-if="mediaItem.videoEmbed && mediaItem.videoEmbed.length > 0 && mediaItem.videoEmbed[0].videoUrl"
            :video="mediaItem">
          </media-video-excerpt>

          <media-collection-item
            v-else
            :product-id="productId"
            :media-item="mediaItem">
          </media-collection-item>

        </el-col>
      </el-row>
    </div>

  </div>
</template>

<script>
  import MediaCollectionItem from '@/components/MediaCollectionItem.vue';
  import MediaCollectionCallout from '@/components/MediaCollectionCallout.vue';
  import MediaVideoExcerpt from '@/components/media/MediaVideoExcerpt.vue';

  export default {
    name: 'MediaCollections',
    props: {
      productId: {},
      collection: {}
    },
    components: {
      MediaCollectionItem,
      MediaCollectionCallout,
      MediaVideoExcerpt
    }
  }
</script>

<style lang="scss" scoped>

  .media-collections {
    margin: 30px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

</style>
